import { useTranslation } from 'react-i18next';
import logo from '../static/images/temporary_logo.png';
import { GreenButton, GreyButton } from './buttons';

const PwaModal = ({ sendBackReply }) => {
    const { t } = useTranslation();
    return (
        <div className="fixed inset-0 bg-black/70 z-50 flex flex-col items-center justify-center">
            <div className='bg-white p-6 m-4 max-w-[600px] rounded-xl flex flex-col gap-2'>
                <div>{t("PwaModal.first")} <b>TicinoWild</b> {t("PwaModal.second")}</div>
                <div className='flex flex-col ml-2 my-4 shadow w-fit'>
                    <img src={logo} alt="Logo TicinoWild" className='w-48' />
                    <h6 className='text-neutral-400 ml-2'>www.ticinowild.ch</h6>
                </div>

                {/* Buttons */}
                <div className='flex gap-4 w-full justify-end'>
                    <GreyButton text="Annulla" click={() => sendBackReply('no')} />
                    <GreenButton text="Aggiungi" click={() => sendBackReply('yes')} />
                </div>
            </div>
        </div>
    )
}

export default PwaModal